(function($) {
    $(() => {
        var $ = jQuery;
        function scrollTo(id, plusoffset){
            $('html,body').animate({
                    scrollTop: $("#"+id).offset().top - 80 - plusoffset
                },
                'slow');
        }

        $(".upbutton").click(function(e) {
            e.preventDefault();
            scrollTo("start", 0);
        });

        $(".scrolldown").click(function(e) {
            e.preventDefault();
            scrollTo("scroll-here", -35);
        });

        $(".scrollkapcsolat").click(function(e) {
            e.preventDefault();
            scrollTo("kapcsolat", 30);
        });

        $(".scrollfb").click(function(e) {
            e.preventDefault();
            scrollTo("fb-feed", 20);
        });

        if (!/Android|iPhone|iPad|iPod|BlackBerry|Windows Phone/i.test(navigator.userAgent || navigator.vendor || window.opera)) {
            skrollr.init({
                forceHeight: false,
                smoothScrolling: true
            });
        }

        if ($('.youtube-player').length) {
            $('.youtube-player').each(function () {
                $(this).append('<iframe src="https://www.youtube.com/embed/' + $(this).data('id') + '?autoplay=0&rel=0&enablejsapi=1&modestbranding=1&disablekb=1&origin=' + document.location.origin + '" frameborder="0" allowfullscreen="1"></iframe>');
            });
        }

        $(document).on('click','.navbar-collapse.in',function(e) {
            $(this).collapse('hide');
        });
    });
})(jQuery);
